(function(){
    'use strict'

    var serviceName = '$animationsSrv';

    angular.module('app.core').factory(serviceName, animationsSrv);

    function animationsSrv() {
        
        var service = {
            scrollToTop: scrollToTop
        };

        return service;

        function scrollToTop($var) {
            // 'html, body' denotes the html element, to go to any other custom element, use '#elementID'
            $('html, body').animate({
                scrollTop: 0
            }, 'fast'); // 'fast' is for fast animation
        };
    }
})();